import React from 'react';
import Header from '../components/Header';
import Contact from './Contact';
import Footer from '../components/Footer';
import useSEO from '../components/SEO';

const ContactPage: React.FC = () => {
    useSEO({
        title: "Contact - ISTMECH",
        description: "Formulaire de contact, coordonnées et informations pratiques pour joindre l'ISTMECH.",
        keywords: "ISTMECH, contact, adresse, téléphone, email",
        url: "https://www.istmech.edu.ht/contact",
        image: "https://www.istmech.edu.ht/og-image.png"
    });

    return (
        <div className="App">
            <Header />
            <main className="pt-20">
                <Contact />
            </main>
            <Footer />
        </div>
    );
};

export default ContactPage;
